<template>
  <div>
    <div v-for="(condition, index) in meta_conditions" :key="index">
      <div class="row px-3 mb-2">
        <LabelValue  v-if="condition.meta_key == 'selection_type: '" :classCustom="'col-4'" label="Selected Type" :value="condition.meta_value" />
      </div>
  
      <div v-if="condition.meta_key == 'day_inactive_since'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Inactive Since: " :value="`${condition.meta_value} Day(s)`" />
      </div>
  
      <div v-if="condition.meta_key == 'all_users'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Selected: " :value="`${condition.meta_value}`" />
      </div>
  
  
      <div v-if="condition.meta_key == 'age_range'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Age Range" :value="`From: ${condition.meta_value.age_from} To: ${condition.meta_value.age_to}`" />
      </div>
  
  
      <div v-if="condition.meta_key == 'gender'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Gender: " :value="condition.meta_value.value" />
      </div>
  
      <div v-if="condition.meta_key == 'select_tier'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Selected Tier(s): " :value="formattedTiers(condition.meta_value)" />
      </div>
  
      <div v-if="condition.meta_key == 'point_range'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Point Range: " :value="`From: ${JSON.parse(condition.meta_value).tier_from} To: ${JSON.parse(condition.meta_value).tier_to}`" />
      </div>
  
      <div v-if="condition.meta_key == 'expiry_in'" class="mb-2">
        <LabelValue :classCustom="'col-4'" label="Point Expire In: " :value="`${JSON.parse(condition.meta_value).days} Days`" />
      </div>
    </div>
  </div>
</template>

<script>
import LabelValue from '../../../components/UI/LabelValue.vue';

export default {
  components: { LabelValue },
  
  props: {
    meta_conditions: {
      type: Array,
      required: true
    },
  },

  data() {
    return {
      tiers: {
        1: 'Silver',
        2: 'Gold',
        3: 'Platinum',
        4: 'Black'
      }
    }
  },
  
  methods: {
    formattedTiers(data) {
      data = JSON.parse(data);
      return data.map(id => this.tiers[id]).join(', ');
    }
  },
}
</script>
